<template>
  <el-dialog
    :show-close="false"
    :title="title"
    :visible.sync="dialogVisible"
    @close="onClose"
    width="400px"
  >
    <slot></slot>
    <template v-slot:footer>
      <el-button type="primary" @click="dialogVisible = false">确定</el-button>
    </template>
  </el-dialog>
</template>
<script>
export default {
  name: "Alert",
  props: {
    title: {
      type: String,
      default: "提示",
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialogVisible: this.show,
    };
  },
  watch: {
    show(value) {
      this.dialogVisible = value;
    },
    dialogVisible(value) {
      if (!value) {
        this.$emit("update:show", value);
      }
    },
  },
  methods: {
    onClose() {
      this.$emit("close");
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/ {
  .el-dialog {
    box-sizing: border-box;
    padding: 16px 24px 24px 24px;
  }
  .el-dialog__header {
    padding: 0;
  }
  .el-dialog__body {
    padding: 16px 0 24px 0;
  }
  .el-dialog__footer {
    padding: 0;
  }
  .el-dialog__title {
    font-size: 18px;
    font-family: PingFang SC, PingFang SC-Medium;
    font-weight: 500;
    color: #333333;
    line-height: 24px;
  }
}
</style>
